import { Link } from 'react-router-dom';
import { useCookieConsent } from '../contexts/CookieConsentContext';

const CookieBanner = () => {
  const { hasConsent, setHasConsent } = useCookieConsent();

  if (hasConsent) {
    return null;
  }

  return (
    <div className="fixed bottom-0 inset-x-0 bg-zinc-900 text-white text-sm px-4 py-3 flex flex-col sm:flex-row sm:items-center sm:justify-between z-50 shadow-lg">
      <p className="mb-2 sm:mb-0">
        This website uses cookies to enhance your browsing experience. By continuing to use this site, you accept our use of cookies.
        <Link to="/privacy-policy" className="underline ml-1">Learn more</Link>.
      </p>
      <button 
        className="bg-white text-zinc-900 font-semibold px-4 py-1 rounded"
        onClick={() => setHasConsent(true)}
      >
        Got it
      </button>
    </div>
  );
};

export default CookieBanner;